/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Sources_TitleInputs */

const vi_sl_new_sources_title = /** @type {(inputs: Sl_New_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu cân chè khô nguồn`)
};

/**

* @param {Sl_New_Sources_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_sources_title = /** @type {((inputs?: Sl_New_Sources_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Sources_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_sources_title(inputs)
});